module.exports = __webpack_public_path__ + "/images//no-image-50.png";


//////////////////
// WEBPACK FOOTER
// ./images/no-image-50.png
// module id = 149
// module chunks = 0